import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const DieselCard = ({ roles }) => {

    return (
        <M_Table entityName={'FuelCard'} filtersOnTable rolePermissions={roles} />
    )
}